import React, { useContext } from 'react';
import { FaBell, FaCheckDouble, FaTrashAlt } from 'react-icons/fa';
import axios from 'axios';
import Swal from 'sweetalert2';

import AppContext from '../../../context/AppContext';
import AdmNotiList from '../../../subscreens/admin/AdminNotifications/AdmNotiList';

import '../../../assets/css/admin/adminNotifications/adminNotification.css';

const AdminNotifications = () => {
  const { authToken, baseUrl, notifications, setnotification } = useContext(AppContext);

  const unreadCount = notifications.filter((n) => n.status === 'unread').length;

  const stats = [
    {
      label: 'Total',
      value: notifications.length,
      icon: '🔔',
      bg: '#E8F4F8',
      color: '#2C5F7C',
    },
    {
      label: 'Unread',
      value: unreadCount,
      icon: '📩',
      bg: '#FFF8E1',
      color: '#FFB800',
    },
    {
      label: 'Read',
      value: notifications.length - unreadCount,
      icon: '✅',
      bg: '#E8F8EA',
      color: '#28A745',
    },
  ];

  const handleMarkAllRead = () => {
    axios.post(
      `${baseUrl}/admin/view-adminnotireadall`,
      {},
      {
        headers: { Authorization: `Bearer ${authToken}` },
      }
    )
    .then(() => {
      setnotification((prev) =>
        prev.map((n) => ({ ...n, status: 'read' }))
      );
    })
    .catch((err) => console.error('Mark all read error:', err));
  };

  const handleClearAll = () => {
    Swal.fire({
      title: 'Remove all notifications?',
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DC3545',
      confirmButtonText: 'Yes, remove all',
    }).then((result) => {
      if (!result.isConfirmed) return;

      axios.delete(
        `${baseUrl}/admin/view-adminnotideleteall`,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      )
      .then(() => {
        setnotification([]);
        Swal.fire('Removed!', 'All notifications removed successfully.', 'success');
      })
      .catch((err) => {
        Swal.fire('Error', err.response?.data?.message || 'Failed to remove notifications.', 'error');
      });
    });
  };

  return (
    <div className="jj-fade-in-up">

      <div className="jj-page-header">
        <h2 className="jj-page-title">Notifications</h2>
        <p className="jj-page-subtitle">
          View and manage all system notifications
        </p>
      </div>

      <div className="adm-noti-page">
        <div className="adm-noti-header">
          <div className="adm-noti-header-left">
            <div className="adm-noti-bell">
              <FaBell />
              {unreadCount > 0 && (
                <span className="adm-noti-badge">{unreadCount}</span>
              )}
            </div>
            <div className="adm-noti-header-text">
              <h1>Notifications</h1>
              <p>
                {unreadCount > 0
                  ? `You have ${unreadCount} unread notification${unreadCount > 1 ? 's' : ''}`
                  : "You're all caught up!"}
              </p>
            </div>
          </div>

          <div className="adm-noti-header-actions">
            {unreadCount > 0 && (
              <button className="adm-noti-btn" onClick={handleMarkAllRead}>
                <FaCheckDouble /> Mark All Read
              </button>
            )}
            {notifications.length > 0 && (
              <button className="adm-noti-btn danger" onClick={handleClearAll}>
                <FaTrashAlt /> Clear All
              </button>
            )}
          </div>
        </div>

        <div className="adm-noti-stats">
          {stats.map((s) => (
            <div key={s.label} className="adm-noti-stat-card">
              <div
                className="adm-noti-stat-icon"
                style={{ backgroundColor: s.bg }}
              >
                <span style={{ fontSize: '22px' }}>{s.icon}</span>
              </div>
              <div>
                <p className="adm-noti-stat-value">{s.value}</p>
                <p className="adm-noti-stat-label">{s.label}</p>
              </div>
            </div>
          ))}
        </div>

        <AdmNotiList />

      </div>
    </div>
  );
};

export default AdminNotifications;